import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
  EventsByMonth,
  eventsInterviewKey,
  getEnterpriseCalendarEventsInterviewRoute,
  InterviewBlock,
} from '@features/enterpriseEvents';
import axiosInstance from '@server/axiosInstance';

type useGetEnterpriseEventsInterviewData = {
  status: number;
  message: string;
  object: InterviewBlock[];
};

type useGetEnterpriseEventsInterviewProps = {
  dateInfo: { month: string, year: string },
  selectedCompanyId: string | number,
  setUpcomingInterviews: Dispatch<SetStateAction<InterviewBlock[]>>;
};

export const useGetEnterpriseEventsInterview = ({
  setUpcomingInterviews,
  dateInfo,
  selectedCompanyId,
}: useGetEnterpriseEventsInterviewProps) => {

  const { isLoading: isUpcommingEventsLoading } =  useQuery<useGetEnterpriseEventsInterviewData>({
    queryKey: [eventsInterviewKey, selectedCompanyId, dateInfo],
    queryFn: () => {
      const params = new URLSearchParams();
      if (selectedCompanyId) {
        params.append('company_id', String(selectedCompanyId));
      }
      params.append('year', String(dateInfo.year));
      params.append('month', String(dateInfo.month));

      const requestUrl = getEnterpriseCalendarEventsInterviewRoute;

      return axiosInstance
        .get(requestUrl, { params })
        .then((res) => res.data)
    },
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data.status === 200) {
        const formattedBlocks: InterviewBlock[] =
          data?.object?.map((block: InterviewBlock) => ({
            ...block,
            event: block,
          })) ?? [];
        setUpcomingInterviews([...formattedBlocks]);
      } else {
        setUpcomingInterviews([]);
      }
    },
  });
  return { isUpcommingEventsLoading };
};
